import React, { FC, useState } from 'react';
import { Calendar } from 'react-feather';
import { Dayjs } from 'dayjs';

import { PVBlack } from '@pv/common/colors';
import { offsetToTimeString } from '@pv/common/utils';

import type { FilterBarProps } from './index';
import type { Nullable } from '../../../types/common';
import { MobileFilterBarDialog } from './MobileFilterBarDialog';
import { MobileFilterBarButton } from '../MobileFilterBarButton';
import { getCapacityText } from '../utils';

export const MobileFilterBar: FC<FilterBarProps> = ({
  eventDate,
  onChangeEventDate,
  startTime,
  onChangeStartTime,
  clearStartTime,
  endTime,
  onChangeEndTime,
  clearEndTime,
  capacityFilterValues,
  onSubmitCapacityFilter,
  onCancelCapacityFilter,
  expressBookSettings,
  hoursOfOperation,
}: FilterBarProps) => {
  const [open, setOpen] = useState(false);
  const handleClick = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const capacityText = getCapacityText(capacityFilterValues);

  return (
    <div role="search" style={{ width: '103%' }}>
      <MobileFilterBarButton
        startIcon={<Calendar color={PVBlack} />}
        filterText={[
          displayDateAndTime(eventDate, startTime, endTime),
          capacityText,
        ]}
        onClick={handleClick}
      />

      <MobileFilterBarDialog
        isOpen={open}
        onClose={handleClose}
        eventDate={eventDate}
        onChangeEventDate={onChangeEventDate}
        startTime={startTime}
        onChangeStartTime={onChangeStartTime}
        clearStartTime={clearStartTime}
        endTime={endTime}
        onChangeEndTime={onChangeEndTime}
        clearEndTime={clearEndTime}
        capacityFilterValues={capacityFilterValues}
        onSubmitCapacityFilter={onSubmitCapacityFilter}
        onCancelCapacityFilter={onCancelCapacityFilter}
        expressBookSettings={expressBookSettings}
        hoursOfOperation={hoursOfOperation}
      />
    </div>
  );
};

/*
 * Helpers.
 */

function displayDateAndTime(
  eventDate: Nullable<Dayjs>,
  startTime: Nullable<number>,
  endTime: Nullable<number>,
) {
  if (!eventDate && !startTime && !endTime) {
    return 'Any Date & Time';
  }

  const displayDate = eventDate?.format('MMM DD, YYYY') ?? 'Any Date';

  if (!startTime || !endTime) {
    return `${displayDate} at Any Time`;
  }

  const displayStartTime = offsetToTimeString(startTime);
  const displayEndTime = offsetToTimeString(endTime);

  return `${displayDate} at ${displayStartTime} - ${displayEndTime}`;
}
